<template functional>
  <div class="site-footer-wrapper">
    <div v-if="props.variant === 'home'" class="section_2 flex-col">
      <div class="block_11 flex-row justify-between">
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            src="@/views/home/assets/img/SketchPng939c4943e2f8acdbf484792c3849860d6a019f961923747514e6cbcc65fc8b5c.png"
          />
          <span class="text-group_4">推动药物创新&nbsp;&nbsp;赋能生命健康</span>
        </div>
        <span class="text_20">
          <router-link to="/">首页</router-link>&nbsp;｜&nbsp;<router-link to="/research">科研实力</router-link>&nbsp;｜&nbsp;<router-link to="/news">新闻中心</router-link>
        </span>
      </div>
      <img
        class="image_8"
        referrerpolicy="no-referrer"
        src="@/views/home/assets/img/SketchPng6f4206acdad8e124f71f3dfaecd91ab2734df54f189c6ef7b9dd8981b184c9d5.png"
      />
      <div class="text-wrapper_9">
        <span class="text_21">Copyright</span>
        <span class="text_22">©️</span>
        <span class="text_23">&nbsp;北京皓溶生物科技有限公司&nbsp;版权所有</span>
      </div>
    </div>

    <div v-else-if="props.variant === 'research'" class="box_11 flex-col">
      <div class="box_20 flex-row justify-between">
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            src="@/views/research/assets/img/SketchPng939c4943e2f8acdbf484792c3849860d6a019f961923747514e6cbcc65fc8b5c.png"
          />
          <span class="text-group_1">推动药物创新&nbsp;&nbsp;赋能生命健康</span>
        </div>
        <span class="text_22">
          <router-link to="/">首页</router-link>&nbsp;｜&nbsp;<router-link to="/research">科研实力</router-link>&nbsp;｜&nbsp;<router-link to="/news">新闻中心</router-link>
        </span>
      </div>
      <img
        class="image_7"
        referrerpolicy="no-referrer"
        src="@/views/research/assets/img/SketchPng6f4206acdad8e124f71f3dfaecd91ab2734df54f189c6ef7b9dd8981b184c9d5.png"
      />
      <div class="text-wrapper_16">
        <span class="text_23">Copyright</span>
        <span class="text_24">©️</span>
        <span class="text_25">&nbsp;北京皓溶生物科技有限公司&nbsp;版权所有</span>
      </div>
    </div>

    <div v-else-if="props.variant === 'news'" class="box_23 flex-col">
      <div class="group_25 flex-row justify-between">
        <div class="image-text_24 flex-col justify-between">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            src="@/views/news/assets/img/SketchPng939c4943e2f8acdbf484792c3849860d6a019f961923747514e6cbcc65fc8b5c.png"
          />
          <span class="text-group_12">推动药物创新&nbsp;&nbsp;赋能生命健康</span>
        </div>
        <span class="text_31">
          <router-link to="/">首页</router-link>&nbsp;｜&nbsp;<router-link to="/research">科研实力</router-link>&nbsp;｜&nbsp;<router-link to="/news">新闻中心</router-link>
        </span>
      </div>
      <img
        class="image_10"
        referrerpolicy="no-referrer"
        src="@/views/news/assets/img/SketchPng6f4206acdad8e124f71f3dfaecd91ab2734df54f189c6ef7b9dd8981b184c9d5.png"
      />
      <div class="text-wrapper_3">
        <span class="text_32">Copyright</span>
        <span class="text_33">©️</span>
        <span class="text_34">&nbsp;北京皓溶生物科技有限公司&nbsp;版权所有</span>
      </div>
    </div>

    <div v-else-if="props.variant === 'news-detail'" class="block_6 flex-col">
      <div class="box_5 flex-row justify-between">
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="@/views/news-detail/assets/img/SketchPng939c4943e2f8acdbf484792c3849860d6a019f961923747514e6cbcc65fc8b5c.png"
          />
          <span class="text-group_1">推动药物创新&nbsp;&nbsp;赋能生命健康</span>
        </div>
        <span class="text_12">
          <router-link to="/">首页</router-link>&nbsp;｜&nbsp;<router-link to="/research">科研实力</router-link>&nbsp;｜&nbsp;<router-link to="/news">新闻中心</router-link>
        </span>
      </div>
      <div class="box_6 flex-row">
        <div class="text-wrapper_4">
          <span class="text_13">Copyright</span>
          <span class="text_14">©️</span>
          <span class="text_15">&nbsp;北京皓溶生物科技有限公司&nbsp;版权所有</span>
        </div>
      </div>
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        src="@/views/news-detail/assets/img/SketchPng6f4206acdad8e124f71f3dfaecd91ab2734df54f189c6ef7b9dd8981b184c9d5.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteFooter',
  functional: true,
  props: {
    variant: {
      type: String,
      required: true
    }
  }
};
</script>
